import { FunctionComponent } from 'react'
import { Label as LabelProps } from './Label.types'
import { Text } from '../Text/Text'
import { Icon } from '../Icon/Icon'
import classNames from 'classnames'
import './Label.scss'

export const Label: FunctionComponent<LabelProps> = ({
  attributes,
  className
}) => {
  if (!attributes) {
    return null
  }

  const { text, icon, iconPosition = 'START', backgroundColor } = attributes

  return (
    <div
      className={classNames('core-ux-label', className)}
      style={{ backgroundColor }}
      data-testid="label">
      {icon && (
        <Icon
          type={icon.type}
          version={icon.version}
          attributes={icon.attributes}
          className={classNames(
            `core-ux-label__icon core-ux-label__icon--${iconPosition.toLowerCase()}`,
            icon.className
          )}
        />
      )}
      <Text
        type={text.type}
        version={text.version}
        attributes={text.attributes}
      />
    </div>
  )
}
